import React, { Component } from 'react';
import 'swiper/dist/css/swiper.css';
import '../assets/stylesheets/Features.css';
import ReactSwiper from 'react-swiper-dy';

import image1 from '../assets/images/phone-1.jpg';
import image2 from '../assets/images/phone-2.jpg';
import image3 from '../assets/images/phone-3.jpg';
import image4 from '../assets/images/phone-4.jpg';

class Features extends Component {

  constructor(props) {
    super(props);

    this.prev = this.prev.bind(this);
    this.next = this.next.bind(this);
    this.renderSlide = this.renderSlide.bind(this);
  }

  next() {
    this.refs.reactSwiper.next(null, 300);
  }

  prev() {
    this.refs.reactSwiper.prev(null, 300);
  }

  renderNextSlideButton(title, paired) {
    let btnClasses = "td-btn";

    if (paired) {
      btnClasses = "td-btn td-btn-next";
    }

    return (
      <a className={btnClasses} onClick={this.next}>Next: {title} <i className="icon icon-chevron-right"></i></a>
    )
  }

  renderPrevSlideButton(title, paired) {
    let btnClasses = "td-btn";

    if (paired) {
      btnClasses = "td-btn td-btn-prev";
    }

    return (
      <a className={btnClasses} onClick={this.prev}><i className="icon icon-chevron-left"></i> {title}</a>
    )
  }

  renderSlideNav(index, nextSlide) {
    if (nextSlide && index === 0) {
      return(this.renderNextSlideButton(nextSlide.title))
    } else if (nextSlide) {
      return (
        <div>
          {this.renderPrevSlideButton(null, true)}
          {this.renderNextSlideButton(nextSlide.title, true)}
        </div>
      )
    } else {
      return (this.renderPrevSlideButton('Back'))
    }
  }

  renderSlide(slide, index, nextSlide) {

    return (
      <div className="swiper-slide" key={index}>
        <div className="page-container-responsive">
          <div className="row">
            <div className="col-sm-12 col-md-5 swiper-text-height text-center-sm">
              <div className="phone-frame">
                <img src={slide.image} className="phone-screen space-0" alt={slide.title} />
              </div>
            </div>
            <div className="col-sm-12 col-md-7 swiper-text-height text-center-sm">
              <div className="va-container va-container-v va-container-h">
                <div className="va-middle">
                  <div className="space-top-3 show-sm"></div>
                  <h3 className="space-2"><b>{slide.title}</b></h3>
                  <h3 className="space-3">{slide.description}</h3>

                  {this.renderSlideNav(index, nextSlide)}

                  <div className="space-top-3 show-sm"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }

  render() {

    const swipeOptions = {
      "speed": 10
    }

    const slides = [
      {
        "title": "Control",
        "image": image1,
        "description": "You can create key codes that will always work, or that are only valid during certain time periods that you set.   You also receive notifications when those keys are used, telling you who has entered the building and when."
      },
      {
        "title": "Flexibility",
        "image": image2,
        "description": "When someone shows up without a key code, your intercom can call any number to request entry for that guest. Leaving for vacation abroad? No problem, forward the call to someone else."
      },
      {
        "title": "Fast Access",
        "image": image3,
        "description": "You can set up the app to recognize when you approach your home.  When you get to the intercom box, just dial your listing, and Tiny Doorman will let you straight in, without even asking you for a key code."
      },
      {
        "title": "Convenience",
        "image": image4,
        "description": "Create and text a key to a friend with just a few clicks- or put a key in your Amazon or Instacart delivery notes.  It’s easy to create and distribute keys for all your trusted visitors!"
      }
    ]

    return (
      <div className="features space-top-4">
        <div className="swiper-container" id="feature-points">
          <ReactSwiper ref="reactSwiper" swipeOptions={swipeOptions}>
            { slides.map((slide, index) => {
              return this.renderSlide(slide, index, slides[index+1])
            })}
          </ReactSwiper>
          <div className="space-top-3 space-3 show-sm">
            <div className="swiper-pagination"></div>
          </div>
        </div>
      </div>
    );
  }
}

export default Features;



/** WEBPACK FOOTER **
 ** ./src/components/Features.js
 **/